export const movieCatalog = {
  action: [
    {
      genres: ['Action', 'Adventure', 'Thriller'],
      movieId: '10',
      name: 'GoldenEye',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMzk2OTg4MTk1NF5BMl5BanBnXkFtZTcwNjExNTgzNA@@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Fantasy'],
      movieId: '44',
      name: 'Mortal Kombat',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNjY5NTEzZGItMGY3My00NzE4LThkYTUtYjJkNzk3MDBiMWE3XkEyXkFqcGdeQXVyNzg5MDE1MDk@._V1_.jpg',
    },
    {
      genres: ['Action', 'Thriller', 'Western'],
      movieId: '303',
      name: 'The Quick and The Dead',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BOTI2ZTZmMmItMmM3YS00ZjUwLWJiODMtMmRjMWM4NDE0OWFhXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Thriller'],
      movieId: '434',
      name: 'Cliffhanger',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYWE4MTYxMDYtMTgzNi00NWNjLTk5NjItMmRkNDU3N2FiMTczXkEyXkFqcGdeQXVyMjMwNDgzNjc@._V1_.jpg',
    },
    {
      genres: ['Action', 'Crime'],
      movieId: '544',
      name: 'Striking Distance',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTQzMDEwMTc5N15BMl5BanBnXkFtZTgwMzczNjQxMTE@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure'],
      movieId: '761',
      name: 'The Phantom',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMGE3MjRhZjUtZGQ0My00ZGM4LWI4YmMtMDYwM2ZjYTQ1ZWNkL2ltYWdlL2ltYWdlXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Action', 'Crime', 'Fantasy', 'Thriller'],
      movieId: '353',
      name: 'The Crow',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BM2Y4ZGVhZjItNjU0OC00MDk1LWI4ZTktYTgwMWJkNDE5OTcxXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Action', 'Crime', 'Thriller'],
      movieId: '1036',
      name: 'Die Hard',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZjRlNDUxZjAtOGQ4OC00OTNlLTgxNmQtYTBmMDgwZmNmNjkxXkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_.jpg',
    },
    {
      genres: ['Action', 'Romance'],
      movieId: '1101',
      name: 'Top Gun',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYTgzYTg5NTMtMjFmMy00MWIxLWEwYTQtN2UyMzY3NDIzOTRjL2ltYWdlXkEyXkFqcGdeQXVyNjQzNDI3NzY@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Fantasy'],
      movieId: '1275',
      name: 'Highlander',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMjc3YmU3MzQtNTA4OC00ZjljLWFmODAtZDU1YzY5ZTNkZDU3XkEyXkFqcGdeQXVyNTAyODkwOQ@@._V1_.jpg',
    },
    {
      genres: ['Action', 'Comedy', 'Western'],
      movieId: '1378',
      name: 'Young Guns',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BODA0MWZhNjctZWUxYy00OThjLWJkNGQtZjNlNGMzY2Y0MDBjXkEyXkFqcGdeQXVyMjY3MjUzNDk@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Thriller'],
      movieId: '1552',
      name: 'Con Air',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMGZmNGIxMTYtMmVjMy00YzhkLWIyOTktNTExZGFiYjNiNzdlXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Thriller'],
      movieId: '1610',
      name: 'The Hunt for Red October',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZDdkODg3YzctMGVmZS00ZDM5LWIzNTctZDRlMjA5Mjc4MGViXkEyXkFqcGdeQXVyODE5NzE3OTE@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Thriller'],
      movieId: '1722',
      name: 'Tomorrow Never Dies',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTM1MTk2ODQxNV5BMl5BanBnXkFtZTcwOTY5MDg0NA@@._V1_.jpg',
    },
    {
      genres: ['Action', 'Drama', 'War'],
      movieId: '2028',
      name: 'Saving Private Ryan',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZjhkMDM4MWItZTVjOC00ZDRhLThmYTAtM2I5NzBmNmNlMzI1XkEyXkFqcGdeQXVyNDYyMDk5MTU@._V1_.jpg',
    },
    {
      genres: ['Action', 'Thriller'],
      movieId: '2353',
      name: 'Enemy of the State',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMWI0Y2NhMzMtYTE5ZS00MDlhLTg0ZjEtMjAwZmEwNTc0ODc2XkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_.jpg',
    },
    {
      genres: ['Action', 'Drama'],
      movieId: '2411',
      name: 'Rocky IV',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTg3ODk5ODE0NV5BMl5BanBnXkFtZTcwNDkzODM1NA@@._V1_.jpg',
    },
    {
      genres: ['Action', 'War'],
      movieId: '2815',
      name: 'Iron Eagle',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZGY3MWIzZGYtOTliMy00YzQzLTgwNjgtNjlkYTA2Y2Y5YTVkL2ltYWdlXkEyXkFqcGdeQXVyNjQzNDI3NzY@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure'],
      movieId: '3030',
      name: 'Yojimbo',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZThiZjAzZjgtNDU3MC00YThhLThjYWUtZGRkYjc2ZWZlOTVjXkEyXkFqcGdeQXVyNTA4NzY1MzY@._V1_.jpg',
    },
    {
      genres: ['Action', 'Romance', 'Western'],
      movieId: '163',
      name: 'Desperado',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYjA0NDMyYTgtMDgxOC00NGE0LWJkOTQtNDRjMjEzZmU0ZTQ3XkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Action', 'Drama', 'War'],
      movieId: '110',
      name: 'Braveheart',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMzkzMmU0YTYtOWM3My00YzBmLWI0YzctOGYyNTkwMWE5MTJkXkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_.jpg',
    },
    {
      genres: ['Action', 'Romance', 'Thriller'],
      movieId: '377',
      name: 'Speed',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYjc0MjYyN2EtZGRhMy00NzJiLWI2Y2QtYzhiYTU3NzAxNzg4XkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Action', 'Thriller'],
      movieId: '474',
      name: 'In the Line of Fire',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMjdhYjRlMTgtNTMzOS00OTZlLWIxMjAtNjM4NGY0NGQxODM3XkEyXkFqcGdeQXVyNDk3NzU2MTQ@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Sci-Fi'],
      movieId: '3702',
      name: 'Mad Max',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTM4Mjg5ODEzMV5BMl5BanBnXkFtZTcwMDc3NDk0NA@@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Mystery', 'Thriller'],
      movieId: '648',
      name: 'Mission: Impossible',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTc3NjI2MjU0Nl5BMl5BanBnXkFtZTgwNDk3ODYxMTE@._V1_.jpg',
    },
    {
      genres: ['Action'],
      movieId: '3444',
      name: 'Bloodsport',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNTJmMGEzMTQtMzQzMi00YjE1LWI4MTctNjY0NWZiYzE2MDVhXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Action', 'Drama', 'Thriller', 'War'],
      movieId: '174055',
      name: 'Dunkirk',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZjJlNmUxNGYtMjg2MC00NjBiLTg3MWQtNGFjMmRkYjM0M2E4XkEyXkFqcGdeQXVyMjI4MjA5MzA@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Thriller'],
      movieId: '95',
      name: 'Broken Arrow',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYzU2NDg3ZTItNzRmNy00NTQzLTljMDUtNjczOTMwZjEzNWVkXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Action', 'Thriller'],
      movieId: '376',
      name: 'The River Wild',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BODA3OWEzZDctMjViNS00NDUzLWEwMDItOGE5YjM4YTE5NWU1XkEyXkFqcGdeQXVyNjYyMTYxMzk@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Thriller'],
      movieId: '733',
      name: 'The Rock',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZDJjOTE0N2EtMmRlZS00NzU0LWE0ZWQtM2Q3MWMxNjcwZjBhXkEyXkFqcGdeQXVyNDk3NzU2MTQ@._V1_.jpg',
    },
    {
      genres: ['Action', 'Mystery', 'Thriller'],
      movieId: '548',
      name: 'Terminal Velocity',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNTU5MTEyMzUtMjUyYi00N2JiLTlmMzEtMWE0NzY4MTk0ZDcxXkEyXkFqcGdeQXVyNjYyMTYxMzk@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Romance', 'Thriller'],
      movieId: '736',
      name: 'Twister',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BODExYTM0MzEtZGY2Yy00N2ExLTkwZjItNGYzYTRmMWZlOGEzXkEyXkFqcGdeQXVyNDk3NzU2MTQ@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Thriller', 'War'],
      movieId: '2404',
      name: 'Rambo III',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BOTIwNWJhZDItZmNmOC00M2NkLWIwNDktMTYwZWFlZDVkMmVkL2ltYWdlXkEyXkFqcGdeQXVyNTAyODkwOQ@@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Thriller'],
      movieId: '2991',
      name: 'Live and Let Die',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMzY0M2MzODYtZDU5Yy00YTg2LWJmMGQtNmY1OWZiYjlmNzY0XkEyXkFqcGdeQXVyNjc1NTYyMjg@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure'],
      movieId: '1198',
      name: 'Raiders of the Lost Ark',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMjA0ODEzMTc1Nl5BMl5BanBnXkFtZTcwODM2MjAxNA@@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Drama', 'Thriller', 'Western'],
      movieId: '5300',
      name: '3:10 to Yuma',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMGNjMzJjOWUtODQzYy00ZGExLThkYjMtZWUwYWQzNjMwOGMzXkEyXkFqcGdeQXVyNjc1NTYyMjg@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Fantasy', 'Thriller'],
      movieId: '5313',
      name: 'The Scorpion King',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMjkxNTAwNTQ0M15BMl5BanBnXkFtZTYwMTQwMjM3._V1_.jpg',
    },
    {
      genres: ['Action', 'Thriller'],
      movieId: '7017',
      name: 'Passenger 57',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BOTIwYzBjZjctMDU4NS00MDUzLTk4MWUtNjdjZGNlMzVjZWFiXkEyXkFqcGdeQXVyMjUzOTY1NTc@._V1_.jpg',
    },
    {
      genres: ['Action', 'Crime', 'Thriller'],
      movieId: '6874',
      name: 'Kill Bill',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNzM3NDFhYTAtYmU5Mi00NGRmLTljYjgtMDkyODQ4MjNkMGY2XkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Drama', 'Fantasy', 'Thriller'],
      movieId: '41569',
      name: 'King Kong',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMjYxYmRlZWYtMzAwNC00MDA1LWJjNTItOTBjMzlhNGMzYzk3XkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Action', 'Fantasy', 'Thriller'],
      movieId: '51077',
      name: 'Ghost Rider',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMzIyNDE5ODI1OV5BMl5BanBnXkFtZTcwNTIyNDE0MQ@@._V1_.jpg',
    },
    {
      genres: ['Action', 'Thriller'],
      movieId: '120466',
      name: 'Chappie',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTUyNTI4NTIwNl5BMl5BanBnXkFtZTgwMjQ4MTI0NDE@._V1_.jpg',
    },
    {
      genres: ['Action', 'Thriller'],
      movieId: '115149',
      name: 'John Wick',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTU2NjA1ODgzMF5BMl5BanBnXkFtZTgwMTM2MTI4MjE@._V1_.jpg',
    },
    {
      genres: ['Action', 'Drama', 'Thriller'],
      movieId: '98961',
      name: 'Zero Dark Thirty',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTQ4OTUyNzcwN15BMl5BanBnXkFtZTcwMTQ1NDE3OA@@._V1_.jpg',
    },
    {
      genres: ['Action', 'Fantasy', 'Horror', 'Thriller'],
      movieId: '95207',
      name: 'Abraham Lincoln: Vampire Hunter',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BNjY2Mzc0MDA4NV5BMl5BanBnXkFtZTcwOTg5OTcxNw@@._V1_.jpg',
    },
    {
      genres: ['Action'],
      movieId: '4441',
      name: 'Game of Death',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNDY2N2EyOTAtMGY4Zi00Mjc3LTkzNTYtNjM2YjNhYjM2MWM5XkEyXkFqcGdeQXVyMTQ2ODE0NDA@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Drama', 'Thriller', 'IMAX'],
      movieId: '91535',
      name: 'The Bourne Legacy',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTc4Njk3MDM1Nl5BMl5BanBnXkFtZTcwODgyOTMxOA@@._V1_.jpg',
    },
    {
      genres: ['Action', 'Drama', 'Thriller', 'War'],
      movieId: '69481',
      name: 'The Hurt Locker',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYWYxZjU2MmQtMmMzYi00ZWUwLTg2ZWQtMDExZTVlYjM3ZWM1XkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_.jpg',
    },
  ],
  comedy: [
    {
      genres: ['Comedy'],
      movieId: '344',
      name: 'Ace Ventura: Pet Detective',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYmVhNmFmOGYtZjgwNi00ZGQ0LThiMmQtOGZjMDUzNzJhMGIzXkEyXkFqcGdeQXVyMTMxODk2OTU@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '19',
      name: 'Ace Ventura: When Nature Calls',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNGFiYTgxZDctNGI4OS00MWU1LWIwOGUtZmMyNGQxYjVkZjQ3XkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '18',
      name: 'Four Rooms',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNDc3Y2YwMjUtYzlkMi00MTljLTg1ZGMtYzUwODljZTI1OTZjXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '65',
      name: 'Bio-Dome',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZWU1NzFlNTItZmM5Ni00ZTgxLWJhZDQtOTBmNWE4ZmEwYjY4XkEyXkFqcGdeQXVyMjcwMzM0OTI@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '69',
      name: 'Friday',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYmEwNjNlZTUtNzkwMS00ZTlhLTkyY2MtMjM2MzlmODQyZGVhXkEyXkFqcGdeQXVyNTI4MjkwNjA@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '88',
      name: 'Black Sheep',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYjc2NzU0YjUtYzkyNS00NjcwLWJiM2QtM2Y3YjFhMTQ0M2I3XkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '104',
      name: 'Happy Gilmore',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZWI2NjliOTYtZjE1OS00YzAyLWJjYTQtYWNmZTQzMTQzNzVjXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'War'],
      movieId: '157',
      name: 'Canadian Bacon',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTUwNDU0NzcwMl5BMl5BanBnXkFtZTcwNzk1NjAzNA@@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '141',
      name: 'The Birdcage',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTM2NjExODYyOF5BMl5BanBnXkFtZTcwNTc0NjgyNA@@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '135',
      name: 'Down Periscope',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMTlkNGU1NDctNDAwZC00ZThlLWE4YTgtMWU5YjJjYzIyY2VjXkEyXkFqcGdeQXVyNTIzOTk5ODM@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '216',
      name: 'Billy Madison',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMzcyMjZmNjctNGNhMS00ZmQxLWFkNzQtYTIxYjVkYmU1NmNmXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '255',
      name: 'The Jerky Boys',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYmVlOTZkNDAtOGMxYy00ZTU4LWIwOTgtZjI2OWIxYTU5OGJiXkEyXkFqcGdeQXVyNzc5MjA3OA@@._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Comedy'],
      movieId: '231',
      name: 'Dumb and Dumber',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZDQwMjNiMTQtY2UwYy00NjhiLTk0ZWEtZWM5ZWMzNGFjNTVkXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '333',
      name: 'Tommy Boy',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNTMwZGU3MGUtZWE0Ni00YzExLWIyY2MtMmNmMDlmYTdmNzFkXkEyXkFqcGdeQXVyNjExODE1MDc@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '413',
      name: 'Airheads',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BY2M3OWY0OTYtZWE5Yy00NDRkLTllYmUtOWVjOTMyZjJjNjhkXkEyXkFqcGdeQXVyMjUzOTY1NTc@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '429',
      name: 'Cabin Boy',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZWI5ZmY5MDMtOWJkYy00YjJlLWI1MDctMjMwZDI3NTY4YmJlXkEyXkFqcGdeQXVyMTEwODg2MDY@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '441',
      name: 'Dazed and Confused',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTM5MDY5MDQyOV5BMl5BanBnXkFtZTgwMzM3NzMxMDE@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '471',
      name: 'The Hudsucker Proxy',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMzNkYzI4ZTYtZjJlZC00ZTVjLTk2MDYtYWMwODA0NmFiYTIwXkEyXkFqcGdeQXVyNDk3NzU2MTQ@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'War'],
      movieId: '473',
      name: 'In the Army Now',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BOWU5MDMzODQtMmM0ZS00MjU5LWExMzMtZjBlOTczY2NjNTMzXkEyXkFqcGdeQXVyMjY3MjUzNDk@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '520',
      name: 'Robin Hood: Men in Tights',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZGYyNmU2NmEtNGU1ZS00YjFkLWI0MWQtZjU2MmUxZDAyN2UxXkEyXkFqcGdeQXVyMTMxODk2OTU@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '637',
      name: 'Sgt. Bilko',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNTA3NTVkZDItMDYzZS00OTFmLTk4ZWQtZjBhYjQwOTI5NjhmXkEyXkFqcGdeQXVyMjc1NDA2OA@@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '784',
      name: 'The Cable Guy',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZTM2YmM4NTAtOTQ0NC00YmZkLTkxYTQtMWQyZWJlZTg0ZjUyXkEyXkFqcGdeQXVyMjUzOTY1NTc@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '785',
      name: 'Kingpin',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BODAzODIyMDYwMV5BMl5BanBnXkFtZTcwMTUyNTEzNA@@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '3175',
      name: 'Galaxy Quest',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNmZlNTY5YjQtZTU5ZC00MzcyLWI1NDMtNjA0ZjQxMmQwYjJmL2ltYWdlXkEyXkFqcGdeQXVyNTAyODkwOQ@@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '6944',
      name: 'Father of the Bride',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYzM0YzBmMTUtN2RmZS00YWY5LWFkZTMtMjM1OWU3Nzk4ZjI1L2ltYWdlL2ltYWdlXkEyXkFqcGdeQXVyNDk3NzU2MTQ@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '1020',
      name: 'Cool Runnings',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMzI2MzI3NDktY2JkMS00YjVlLTk3NTMtY2NhMzEwNWJkNzhmXkEyXkFqcGdeQXVyMDAwMDAwNA@@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '1091',
      name: "Weekend at Bernie's",
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNTQyMTYyYTAtYzU4MS00ODZhLTk1ODEtNjAwNzkxZWUyNzJjXkEyXkFqcGdeQXVyMTg2OTA4OQ@@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '2502',
      name: 'Office Space',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BOTA5MzQ3MzI1NV5BMl5BanBnXkFtZTgwNTcxNTYxMTE@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '1194',
      name: 'Up in Smoke',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMmU3MTNiYjEtODQ5Yy00Y2RiLWIyMjctNGNiNmFmYTA4Y2NhXkEyXkFqcGdeQXVyNzc5MjA3OA@@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '1394',
      name: 'Raising Arizona',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BOGUwZTEwZTYtZmQ0OS00NmM1LWE2ZTQtNjZiYmE4ZmUxMjk1XkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '1461',
      name: 'Vegas Vacation',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZTIwMWEwZmQtMjI1ZS00NDdmLTgwMGItNmFiOTk1ZWQ5NGZiXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '1663',
      name: 'Stripes',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTQ3NzU2NjYyNF5BMl5BanBnXkFtZTgwMjg1MzQxMDE@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '2003',
      name: 'Gremlins',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZDVjN2FkYTQtNTBlOC00MjM5LTgzMWEtZWRlNGUyYmNiOTFiXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Comedy', 'Musical'],
      movieId: '2088',
      name: 'Popeye',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMDgyNDg0YWUtZjNiMy00NzI1LTgzMmQtOGU5NGQwOTA2NDFkXkEyXkFqcGdeQXVyNjE5MjUyOTM@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '2109',
      name: 'The Jerk',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZDNmNThjMTMtNzVlZC00MzgyLWE3M2UtNGQ3ZTZmNjM3YWI2XkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Fantasy'],
      movieId: '2174',
      name: 'Beetlejuice',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BOTRlZTMwOGItMzVjYS00MTFlLTg2YmQtZjY1ODYzNjgyMDRmXkEyXkFqcGdeQXVyNjYyMTYxMzk@._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Comedy'],
      movieId: '2265',
      name: 'Nothing But Trouble',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYjc5MjA1ZWYtNTgxMi00ZTlkLWExZTctMTFkNDFlOTdlZmRkXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '2302',
      name: 'My Cousin Vinny',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZDU0ZjIwN2EtNDAxYi00NzQ2LWEzNGQtN2NlZTY0YmIzZjBiXkEyXkFqcGdeQXVyMTA3MzQ4MTg0._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Sci-Fi'],
      movieId: '3033',
      name: 'Spaceballs',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMTBlNGE0N2EtZDA2OS00OTA3LWFiYjUtODI0YzFmODY3NDExXkEyXkFqcGdeQXVyMjUzOTY1NTc@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Horror', 'Musical'],
      movieId: '2746',
      name: 'Little Shop of Horrors',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYzUxZDI3MjktZmM4YS00MzdjLWE5MzctMmI4M2ViMDgxMmUzXkEyXkFqcGdeQXVyNTAyODkwOQ@@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '2791',
      name: 'Airplane!',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZjA3YjdhMWEtYjc2Ni00YzVlLWI0MTUtMGZmNTJjNmU0Yzk2XkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '2796',
      name: 'Funny Farm',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BM2MyNmQ2ZTQtYzE1Ni00MWQwLWE3ZTctMDcxOWE4ZTQzMjE5L2ltYWdlL2ltYWdlXkEyXkFqcGdeQXVyNzc5MjA3OA@@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '3014',
      name: "Bustin' Loose",
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMjMxNzhmNWUtMDJiNS00ODRjLWFlZmItZWVkNTc2NGE5YTE1XkEyXkFqcGdeQXVyNzc5MjA3OA@@._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Comedy', 'Fantasy'],
      movieId: '3052',
      name: 'Dogma',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYzAyOWUyZjQtNDBiMy00ZDExLTgwNmMtZDdmY2ViNzkyN2Y0XkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '3253',
      name: "Wayne's World",
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMDAyNDY3MjUtYmJjYS00Zjc5LTlhM2MtNzgzYjNlOWVkZjkzL2ltYWdlL2ltYWdlXkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '3421',
      name: 'Animal House',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BM2M2ZDA4MTYtOGRjMi00OTg5LWI1ZTUtMjQxZTc2NWZjNDFkXkEyXkFqcGdeQXVyNDk3NzU2MTQ@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '3489',
      name: 'Hook',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNmJjNTQzMjctMmE2NS00ZmYxLWE1NjYtYmRmNjNiMzljOTc3XkEyXkFqcGdeQXVyNTAyODkwOQ@@._V1_.jpg',
    },
    {
      genres: ['Comedy'],
      movieId: '3552',
      name: 'Caddyshack',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BY2I1NWE2NzctNzNkYS00Nzg5LWEwZTQtN2I3Nzk3MTQwMDY2XkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
  ],
  scifi: [
    {
      genres: ['Mystery', 'Sci-Fi', 'Thriller'],
      movieId: '32',
      name: '12 Monkeys',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BN2Y2OWU4MWMtNmIyMy00YzMyLWI0Y2ItMTcyZDc3MTdmZDU4XkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Action', 'Drama', 'Sci-Fi'],
      movieId: '168612',
      name: 'Ghost in the Shell',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMzJiNTI3MjItMGJiMy00YzA1LTg2MTItZmE1ZmRhOWQ0NGY1XkEyXkFqcGdeQXVyOTk4MTM0NQ@@._V1_.jpg',
    },
    {
      genres: ['Fantasy', 'Sci-Fi'],
      movieId: '1199',
      name: 'Brazil',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMDM0YTM3Y2UtNzY5MC00OTc4LThhZTYtMmM0ZGZjMmU1ZjdmXkEyXkFqcGdeQXVyNjc1NTYyMjg@._V1_.jpg',
    },
    {
      genres: ['Horror', 'Sci-Fi'],
      movieId: '1214',
      name: 'Alien',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BOGQzZTBjMjQtOTVmMS00NGE5LWEyYmMtOGQ1ZGZjNmRkYjFhXkEyXkFqcGdeQXVyMjUzOTY1NTc@._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Film-Noir', 'Sci-Fi', 'Thriller'],
      movieId: '1748',
      name: 'Dark City',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMGExOGExM2UtNWM5ZS00OWEzLTllNzYtM2NlMTJlYjBlZTJkXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Sci-Fi'],
      movieId: '2021',
      name: 'Dune',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYTAzYzNlMDMtMGRjYS00M2UxLTk0MmEtYmE4YWZiYmEwOTIwL2ltYWdlL2ltYWdlXkEyXkFqcGdeQXVyNzc5MjA3OA@@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Horror', 'Sci-Fi'],
      movieId: '1200',
      name: 'Aliens',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZGU2OGY5ZTYtMWNhYy00NjZiLWI0NjUtZmNhY2JhNDRmODU3XkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_.jpg',
    },
    {
      genres: ['Mystery', 'Sci-Fi', 'Thriller'],
      movieId: '70286',
      name: 'District 9',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYmQ5MzFjYWMtMTMwNC00ZGU5LWI3YTQtYzhkMGExNGFlY2Q0XkEyXkFqcGdeQXVyNTIzOTk5ODM@._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Drama', 'Sci-Fi'],
      movieId: '3471',
      name: 'Close Encounters of the Third Kind',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMjM1NjE5NjQxN15BMl5BanBnXkFtZTgwMjYzMzQxMDE@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Sci-Fi'],
      movieId: '3994',
      name: 'Unbreakable',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMDIwMjAxNzktNmEzYS00ZDY5LWEyZjktM2Y0MmUzZDkyYmZkXkEyXkFqcGdeQXVyNTA4NzY1MzY@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Mystery', 'Sci-Fi', 'Thriller'],
      movieId: '4878',
      name: 'Donnie Darko',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZjZlZDlkYTktMmU1My00ZDBiLWFlNjEtYTBhNjVhOTM4ZjJjXkEyXkFqcGdeQXVyMTMxODk2OTU@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Sci-Fi'],
      movieId: '260',
      name: 'Star Wars',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNzg4MjQxNTQtZmI5My00YjMwLWJlMjUtMmJlY2U2ZWFlNzY1XkEyXkFqcGdeQXVyODk4OTc3MTY@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Sci-Fi', 'Thriller'],
      movieId: '480',
      name: 'Jurassic Park',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMjM2MDgxMDg0Nl5BMl5BanBnXkFtZTgwNTM2OTM5NDE@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Sci-Fi'],
      movieId: '316',
      name: 'Stargate',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYWEyYTQzNzQtZTg5OS00NDhkLTg1NjYtMzA5Y2MyYjYzNWQ5L2ltYWdlL2ltYWdlXkEyXkFqcGdeQXVyNTAyODkwOQ@@._V1_.jpg',
    },
    {
      genres: ['Action', 'Sci-Fi', 'Thriller'],
      movieId: '172',
      name: 'Johnny Mnemonic',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNTdhYjEzYTEtYTkwZC00NzgxLWI0ZWEtYmEyMGZhOWYwMjE2XkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Sci-Fi'],
      movieId: '24',
      name: 'Powder',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BOGUzYzNiZTItYmZlNi00ODI1LThjNTMtNjI1MTNlZDQ0OGY2XkEyXkFqcGdeQXVyNjExODE1MDc@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Sci-Fi'],
      movieId: '442',
      name: 'Demolition Man',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMDBmNDhjOTYtZWVlMC00YzUwLWIyZjEtYzFjMWM5OTdiZDJkXkEyXkFqcGdeQXVyNjUwNzk3NDc@._V1_.jpg',
    },
    {
      genres: ['Action', 'Sci-Fi'],
      movieId: '589',
      name: 'Terminator 2: Judgment Day',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMGU2NzRmZjUtOGUxYS00ZjdjLWEwZWItY2NlM2JhNjkxNTFmXkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Sci-Fi', 'Thriller'],
      movieId: '780',
      name: 'Independence Day',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMGQwNDNkMmItYWY1Yy00YTZmLWE5OTAtODU0MGZmMzQ1NDdkXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Drama', 'Sci-Fi'],
      movieId: '924',
      name: '2001: A Space Odyssey',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMmNlYzRiNDctZWNhMi00MzI4LThkZTctMTUzMmZkMmFmNThmXkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Sci-Fi'],
      movieId: '1196',
      name: 'The Empire Strikes Back',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYmU1NDRjNDgtMzhiMi00NjZmLTg5NGItZDNiZjU5NTU4OTE0XkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Sci-Fi'],
      movieId: '1210',
      name: 'Return of the Jedi',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BOWZlMjFiYzgtMTUzNC00Y2IzLTk1NTMtZmNhMTczNTk0ODk1XkEyXkFqcGdeQXVyNTAyODkwOQ@@._V1_.jpg',
    },
    {
      genres: ['Action', 'Sci-Fi', 'Thriller'],
      movieId: '1240',
      name: 'The Terminator',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYTViNzMxZjEtZGEwNy00MDNiLWIzNGQtZDY2MjQ1OWViZjFmXkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Sci-Fi'],
      movieId: '208',
      name: 'Waterworld',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYzE4NTRmMDYtNWYzYi00YmNkLTk4NDEtYjFmMDc4ODQ3ODY2XkEyXkFqcGdeQXVyNTUyMzE4Mzg@._V1_.jpg',
    },
    {
      genres: ['Action', 'Comedy', 'Sci-Fi'],
      movieId: '327',
      name: 'Tank Girl',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMzc0NjBmMzgtMTUxMS00YWFjLTk4NTYtNjE4NTJhOTU3ZTYwXkEyXkFqcGdeQXVyMTMxMTY0OTQ@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Sci-Fi', 'Thriller'],
      movieId: '849',
      name: 'Escape from L.A.',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BOWUzNTRmNTQtNWMwZS00MTg4LThhMDUtYmQ5OGQ5MmNmYzNmXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Sci-Fi', 'Thriller'],
      movieId: '1127',
      name: 'The Abyss',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYWMzMDNlMDQtMTYyYi00OTM3LTllZDYtYThhMTk5MzNhZTRhXkEyXkFqcGdeQXVyMDUyOTUyNQ@@._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Comedy', 'Sci-Fi'],
      movieId: '1270',
      name: 'Back to the Future',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZmU0M2Y1OGUtZjIxNi00ZjBkLTg1MjgtOWIyNThiZWIwYjRiXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Action', 'Comedy', 'Sci-Fi'],
      movieId: '1391',
      name: 'Mars Attacks!',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNThlMjBmOWItNjljZi00ZGU4LWJkZjgtNWU1ZjI1MTg4MzczXkEyXkFqcGdeQXVyNTIzOTk5ODM@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Sci-Fi'],
      movieId: '1584',
      name: 'Contact',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYWNkYmFiZjUtYmI3Ni00NzIwLTkxZjktN2ZkMjdhMzlkMDc3XkEyXkFqcGdeQXVyNDk3NzU2MTQ@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Drama', 'Sci-Fi'],
      movieId: '1682',
      name: 'The Truman Show',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMDIzODcyY2EtMmY2MC00ZWVlLTgwMzAtMjQwOWUyNmJjNTYyXkEyXkFqcGdeQXVyNDk3NzU2MTQ@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Sci-Fi', 'Thriller'],
      movieId: '1921',
      name: 'Pi',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMTk3MThhNGEtY2E4NS00MWMwLTg4MzQtMTk4ZTcwYzRlNDNiXkEyXkFqcGdeQXVyMjUzOTY1NTc@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Sci-Fi'],
      movieId: '2105',
      name: 'Tron',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMzZhNjYyZDYtZmE4MC00M2RlLTlhOGItZDVkYTVlZTYxOWZlXkEyXkFqcGdeQXVyNTAyODkwOQ@@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Sci-Fi', 'IMAX'],
      movieId: '82461',
      name: 'Tron: Legacy',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTk4NTk4MTk1OF5BMl5BanBnXkFtZTcwNTE2MDIwNA@@._V1_.jpg',
    },
    {
      genres: ['Action', 'Sci-Fi', 'Thriller'],
      movieId: '2571',
      name: 'The Matrix',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNzQzOTk3OTAtNDQ0Zi00ZTVkLWI0MTEtMDllZjNkYzNjNTc4L2ltYWdlXkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Sci-Fi', 'Thriller', 'IMAX'],
      movieId: '6365',
      name: 'The Matrix Reloaded',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BODE0MzZhZTgtYzkwYi00YmI5LThlZWYtOWRmNWE5ODk0NzMxXkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Sci-Fi', 'Thriller', 'IMAX'],
      movieId: '6934',
      name: 'The Matrix Revolutions',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNzNlZTZjMDctZjYwNi00NzljLWIwN2QtZWZmYmJiYzQ0MTk2XkEyXkFqcGdeQXVyNTAyODkwOQ@@._V1_.jpg',
    },
    {
      genres: ['Action', 'Comedy', 'Sci-Fi'],
      movieId: '2716',
      name: 'Ghostbusters',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTkxMjYyNzgwMl5BMl5BanBnXkFtZTgwMTE3MjYyMTE@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Sci-Fi', 'Thriller'],
      movieId: '2916',
      name: 'Total Recall',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYzU1YmJjMGEtMjY4Yy00MTFlLWE3NTUtNzI3YjkwZTMxZjZmXkEyXkFqcGdeQXVyNDc2NjEyMw@@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Fantasy', 'Sci-Fi'],
      movieId: '2717',
      name: 'Ghostbusters II',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTQ2NTk4MjE5Ml5BMl5BanBnXkFtZTgwODIwNjYxMTE@._V1_.jpg',
    },
    {
      genres: ['Action', 'Sci-Fi', 'Thriller'],
      movieId: '3527',
      name: 'Predator',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BY2QwYmFmZTEtNzY2Mi00ZWMyLWEwY2YtMGIyNGZjMWExOWEyXkEyXkFqcGdeQXVyNjUwNzk3NDc@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Sci-Fi'],
      movieId: '33004',
      name: "Hitchhiker's Guide to the Galaxy",
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZmU5MGU4MjctNjA2OC00N2FhLWFhNWQtMzQyMGI2ZmQ0Y2YyL2ltYWdlXkEyXkFqcGdeQXVyNTAyODkwOQ@@._V1_.jpg',
    },
    {
      genres: ['Action', 'Sci-Fi'],
      movieId: '3698',
      name: 'The Running Man',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMWU4NzA2OWYtNGQ0MS00YWNkLTg4M2YtZjlkZmY1YmJjMDE4XkEyXkFqcGdeQXVyNDc2NjEyMw@@._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Drama', 'Sci-Fi'],
      movieId: '4370',
      name: 'A.I.',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNWU2NzEyMDYtM2MyOS00OGM3LWFkNzAtMzRiNzE2ZjU5ZTljXkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Sci-Fi'],
      movieId: '4545',
      name: 'Short Circuit',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNjU0YzBhMDQtYmZkZC00NWFiLTkyMDUtZmFhNjk0NGQ5MjFlXkEyXkFqcGdeQXVyMTY4MjE1MDA@._V1_.jpg',
    },
    {
      genres: ['Action', 'Sci-Fi', 'Thriller'],
      movieId: '541',
      name: 'Blade Runner',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNzQzMzJhZTEtOWM4NS00MTdhLTg0YjgtMjM4MDRkZjUwZDBlXkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Sci-Fi', 'Thriller'],
      movieId: '1653',
      name: 'Gattaca',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BODI3ZTc5NjktOGMyOC00NjYzLTgwZDYtYmQ4NDc1MmJjMjRlXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Sci-Fi', 'IMAX'],
      movieId: '109487',
      name: 'Interstellar',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZjdkOTU3MDktN2IxOS00OGEyLWFmMjktY2FiMmZkNWIyODZiXkEyXkFqcGdeQXVyMTMxODk2OTU@._V1_.jpg',
    },
  ],
  horror: [
    {
      genres: ['Action', 'Comedy', 'Horror', 'Thriller'],
      movieId: '70',
      name: 'From Dusk Till Dawn',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZjk3YmZhMDAtOWUzMS00YjE5LTkxNzAtY2I1NGZjMDA2ZTk0XkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Comedy', 'Fantasy', 'Horror'],
      movieId: '1215',
      name: 'Army of Darkness',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BODcyYzM4YTAtNGM5MS00NjU4LTk2Y2ItZjI5NjkzZTk0MmQ1XkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_.jpg',
    },
    {
      genres: ['Horror'],
      movieId: '1258',
      name: 'The Shining',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZWFlYmY2MGEtZjVkYS00YzU4LTg0YjQtYzY1ZGE3NTA5NGQxXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Horror', 'Thriller'],
      movieId: '1333',
      name: 'The Birds',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTAxNDA1ODc5MDleQTJeQWpwZ15BbWU4MDg2MDA4OTEx._V1_.jpg',
    },
    {
      genres: ['Horror', 'Sci-Fi'],
      movieId: '4480',
      name: 'The Blob',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYWIzYjFmZTAtNWMxZS00MmVhLTkyYmEtZjkzZWQwMzg0N2ZjXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Horror', 'Thriller'],
      movieId: '1342',
      name: 'Candyman',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYjVjYjhlNTQtN2UxOC00Njk5LWFjNDctODNjZTI1ZGM0ZDZkXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Horror', 'Thriller'],
      movieId: '1347',
      name: 'A Nightmare on Elm Street',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNzFjZmM1ODgtMDBkMS00NWFlLTg2YmUtZjc3ZTgxMjE1OTI2L2ltYWdlXkEyXkFqcGdeQXVyNTAyODkwOQ@@._V1_.jpg',
    },
    {
      genres: ['Action', 'Horror'],
      movieId: '1387',
      name: 'Jaws',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMmVmODY1MzEtYTMwZC00MzNhLWFkNDMtZjAwM2EwODUxZTA5XkEyXkFqcGdeQXVyNTAyODkwOQ@@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Horror', 'Mystery', 'Thriller'],
      movieId: '1407',
      name: 'Scream',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMjA2NjU5MTg5OF5BMl5BanBnXkFtZTgwOTkyMzQxMDE@._V1_.jpg',
    },
    {
      genres: ['Horror', 'Mystery', 'Thriller'],
      movieId: '1974',
      name: 'Friday the 13th',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNWMxYTYzYWQtNGZmNy00MTg5LTk1N2MtNzQ5NjQxYjQ5NTJhXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Horror'],
      movieId: '1982',
      name: 'Halloween',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNzk1OGU2NmMtNTdhZC00NjdlLWE5YTMtZTQ0MGExZTQzOGQyXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Horror', 'Thriller'],
      movieId: '1991',
      name: "Child's Play",
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZGU1MjNiYWYtNGQ5MS00MTgzLTlkYjItZDhhNTdlMTkxZGVlL2ltYWdlXkEyXkFqcGdeQXVyNTAyODkwOQ@@._V1_.jpg',
    },
    {
      genres: ['Horror', 'Thriller'],
      movieId: '1994',
      name: 'Poltergeist',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNzliZmRlYTctYmNkYS00NzE5LWI1OWQtMTRiODY5MDMwMTVkXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Horror', 'Mystery'],
      movieId: '1997',
      name: 'The Exorcist',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYjhmMGMxZDYtMTkyNy00YWVmLTgyYmUtYTU3ZjcwNTBjN2I1XkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_.jpg',
    },
    {
      genres: ['Horror', 'Thriller'],
      movieId: '2121',
      name: 'Cujo',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNjAxMzIzN2YtMDVlYy00Yzc3LThjOTEtNDlhNjkxMjkwYzYyXkEyXkFqcGdeQXVyMjUzOTY1NTc@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Fantasy', 'Horror'],
      movieId: '2148',
      name: 'House',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZGZkMDc1M2QtOWYyYy00ODZjLTk5OWQtOTI5NDVlYTRkY2FiXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Action', 'Horror', 'Thriller'],
      movieId: '2167',
      name: 'Blade',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BOTk2NDNjZWQtMGY0Mi00YTY2LWE5MzctMGRhZmNlYzljYTg5XkEyXkFqcGdeQXVyMTAyNjg4NjE0._V1_.jpg',
    },
    {
      genres: ['Action', 'Horror', 'Thriller'],
      movieId: '5254',
      name: 'Blade II',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BOWVjZTIzNDYtNTBlNC00NTJjLTkzOTEtOTE0MjlhYzI2YTcyXkEyXkFqcGdeQXVyNTAyODkwOQ@@._V1_.jpg',
    },
    {
      genres: ['Action', 'Horror', 'Sci-Fi', 'Thriller'],
      movieId: '2288',
      name: 'The Thing',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNGViZWZmM2EtNGYzZi00ZDAyLTk3ODMtNzIyZTBjN2Y1NmM1XkEyXkFqcGdeQXVyNTAyODkwOQ@@._V1_.jpg',
    },
    {
      genres: ['Horror', 'Mystery', 'Sci-Fi'],
      movieId: '2455',
      name: 'The Fly',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BODcxMGMwOGEtMDUxMi00MzE5LTg4YTYtYjk1YjA4MzQxNTNlXkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_.jpg',
    },
    {
      genres: ['Horror'],
      movieId: '2513',
      name: 'Pet Sematary',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYjBlNTBhYWQtMzg5Yi00NDA2LWJmMjYtZmM0ODhiYzkwYmY5XkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Action', 'Horror', 'Sci-Fi'],
      movieId: '2614',
      name: 'Chopping Mall',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNjBkZTI0MjQtZmMzYi00ZTI0LTg0NzEtZGI0M2YxMGRmZWZkXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Horror'],
      movieId: '2699',
      name: 'Arachnophobia',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMjExNTcyMjI2Ml5BMl5BanBnXkFtZTgwMDgwNTg4NjE@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Horror', 'Mystery'],
      movieId: '2762',
      name: 'Sixth Sense',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMWM4NTFhYjctNzUyNi00NGMwLTk3NTYtMDIyNTZmMzRlYmQyXkEyXkFqcGdeQXVyMTAwMzUyOTc@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Horror', 'Thriller'],
      movieId: '2867',
      name: 'Fright Night',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYTBlOTEzZjYtZTlmMC00OTYyLWIyMTAtNzMzZTRhNzU1YzAyL2ltYWdlXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Crime', 'Horror'],
      movieId: '1219',
      name: 'Psycho',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNTQwNDM1YzItNDAxZC00NWY2LTk0M2UtNDIwNWI5OGUyNWUxXkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_.jpg',
    },
    {
      genres: ['Horror', 'Mystery'],
      movieId: '3476',
      name: "Jacob's Ladder",
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZTg5MTMyNjktNTZhOC00MGFlLWFlMTMtZGU2MjE3OWQ3NjJkXkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Horror', 'Thriller'],
      movieId: '3499',
      name: 'Misery',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BNzY0ODQ3MTMxN15BMl5BanBnXkFtZTgwMDkwNTg4NjE@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Horror'],
      movieId: '3676',
      name: 'Eraserhead',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMDExYzg5YjQtMzE0Yy00OWJjLThiZTctMWI5MzhjM2RmNjA4L2ltYWdlXkEyXkFqcGdeQXVyNTAyODkwOQ@@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Horror'],
      movieId: '3693',
      name: 'The Toxic Avenger',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNzViNmQ5MTYtMmI4Yy00N2Y2LTg4NWUtYWU3MThkMTVjNjk3XkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Horror'],
      movieId: '3709',
      name: 'Sleepwalkers',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNWY4N2ViZDAtMGU0MS00NDliLWE1NjktN2UyNGEyZjA0YzNhXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Horror'],
      movieId: '3840',
      name: 'Pumpkinhead',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZTY1MWNkOTktNjIyMC00NDEzLWI5MGEtNWYxOTNmYjc2MzNmXkEyXkFqcGdeQXVyMjUzOTY1NTc@._V1_.jpg',
    },
    {
      genres: ['Horror'],
      movieId: '3961',
      name: 'Ghoulies',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZjIzMzhiOTAtNWM0Yy00MGQ4LWJhNDEtMzUzMjY4OTgyYWM5XkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Fantasy', 'Horror', 'Thriller'],
      movieId: '4105',
      name: 'The Evil Dead',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BODc2MmVjZmUtNjAzMS00MDNiLWIyM2YtOGEzMjg0YjRhMzRmXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Horror', 'Thriller'],
      movieId: '4128',
      name: 'The Lost Boys',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMWEzNmUxZTMtZjY0My00OGNmLWIyNDctODM2YzZjM2YwZWEwXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Horror', 'Thriller'],
      movieId: '4148',
      name: 'Hannibal',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZDMxMjhiZmItNWMxMC00NzYyLWJiOTYtNGYwOTAyYjU5OWY4XkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_.jpg',
    },
    {
      genres: ['Horror', 'Sci-Fi', 'Thriller'],
      movieId: '5502',
      name: 'Signs',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BNDUwMDUyMDAyNF5BMl5BanBnXkFtZTYwMDQ3NzM3._V1_.jpg',
    },
    {
      genres: ['Horror', 'Mystery', 'Thriller'],
      movieId: '5679',
      name: 'The Ring',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BNDA2NTg2NjE4Ml5BMl5BanBnXkFtZTYwMjYxMDg5._V1_.jpg',
    },
    {
      genres: ['Horror', 'Sci-Fi', 'Thriller'],
      movieId: '5853',
      name: 'Scanners',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMjFkNDllNTYtNDczMi00NWZkLTg5NjAtNGJiZDMzNTMxOTJiXkEyXkFqcGdeQXVyMjUzOTY1NTc@._V1_.jpg',
    },
    {
      genres: ['Action', 'Horror', 'Thriller'],
      movieId: '6615',
      name: 'Freddy vs. Jason',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BODNlNWVjOTMtZjVjYy00MzRjLTg2MmQtNTM3MWVmZjFjYzgwXkEyXkFqcGdeQXVyMzM4MjM0Nzg@._V1_.jpg',
    },
    {
      genres: ['Action', 'Horror'],
      movieId: '6872',
      name: 'The House of the Dead',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BODcwNzBkMWUtYTRjZS00OWU0LTk3YzItZmVkNGIyYmMwY2U5XkEyXkFqcGdeQXVyMTMxMTY0OTQ@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Fantasy', 'Horror'],
      movieId: '7454',
      name: 'Van Helsing',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BODRmY2NhNDItOWViNi00OTIyLTk3YjYtYzY0YTFlMDg1YzQ0L2ltYWdlL2ltYWdlXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Horror', 'Sci-Fi'],
      movieId: '6659',
      name: 'Tremors',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTEzNjkwMzIyMjZeQTJeQWpwZ15BbWU4MDI2NTU5ODYx._V1_.jpg',
    },
    {
      genres: ['Action', 'Horror', 'Sci-Fi', 'Thriller'],
      movieId: '8810',
      name: 'AVP',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTU4MjIwMTcyMl5BMl5BanBnXkFtZTYwMTYwNDA3._V1_.jpg',
    },
    {
      genres: ['Horror', 'Mystery', 'Thriller'],
      movieId: '8957',
      name: 'Saw',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMzQ2ZTBhNmEtZDBmYi00ODU0LTgzZmQtNmMxM2M4NzM1ZjE4XkEyXkFqcGdeQXVyNjE5MjUyOTM@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Horror', 'Mystery', 'Sci-Fi'],
      movieId: '26558',
      name: 'The Stuff',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZTExOTkyNTMtYjczYS00NWU5LTlkN2ItMTM2MjYzYTVkOWRjXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Horror'],
      movieId: '8874',
      name: 'Shaun of the Dead',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMTg5Mjk2NDMtZTk0Ny00YTQ0LWIzYWEtMWI5MGQ0Mjg1OTNkXkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_.jpg',
    },
    {
      genres: ['Fantasy', 'Horror', 'Thriller'],
      movieId: '45081',
      name: 'Silent Hill',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BOWQzNTU3NGUtNDAxMi00ZjFjLTkyYWUtYjgwZDJiMDljZWY4XkEyXkFqcGdeQXVyNTAyODkwOQ@@._V1_.jpg',
    },
  ],
  drama: [
    {
      genres: ['Drama'],
      movieId: '14',
      name: 'Nixon',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNzBlOWY0ZmEtZjdkYS00ZGU0LWEwN2YtYzBkNDM5ZDBjMmI1XkEyXkFqcGdeQXVyMTAwMzUyOTc@._V1_.jpg',
    },
    {
      genres: ['Drama'],
      movieId: '31',
      name: 'Dangerous Minds',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYjViMWY0YjMtOTc3ZC00MGJjLTkyMGUtZjE5NWIzYmQzZDA2XkEyXkFqcGdeQXVyNjYyMTYxMzk@._V1_.jpg',
    },
    {
      genres: ['Drama'],
      movieId: '62',
      name: "Mr. Holland's Opus",
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMjYzMWM5NDAtZDlkMS00NTNhLWIxNTktNzA3ZjkyMDQ3MWQzXkEyXkFqcGdeQXVyMTA0MjU0Ng@@._V1_.jpg',
    },
    {
      genres: ['Drama'],
      movieId: '147',
      name: 'The Basketball Diaries',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMjdlNzQxZGUtZTg5YS00ODg2LTkxMzctMDAyNmEwM2YyZjA4XkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Drama', 'IMAX'],
      movieId: '150',
      name: 'Apollo 13',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMjc4MzZlNmQtN2ZlOS00OGQzLWI5YjEtNDQ2YmZlN2FjNTIxXkEyXkFqcGdeQXVyMjUzOTY1NTc@._V1_.jpg',
    },
    {
      genres: ['Drama'],
      movieId: '261',
      name: 'Little Women',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNzY2M2IzNWMtMWFkMS00ODk1LWI3NGYtNTBiYTc5MTA0Y2YzXkEyXkFqcGdeQXVyNDA5NTgxNjU@._V1_.jpg',
    },
    {
      genres: ['Drama'],
      movieId: '337',
      name: "What's Eating Gilbert Grape",
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BY2EyZDlhNjItODYzNi00Mzc3LWJjOWUtMTViODU5MTExZWMyL2ltYWdlXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Drama'],
      movieId: '500',
      name: 'Mrs. Doubtfire',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMjExMDUzODE1N15BMl5BanBnXkFtZTgwNTU5NTYxMTE@._V1_.jpg',
    },
    {
      genres: ['Drama'],
      movieId: '508',
      name: 'Philadelphia',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNDE0MWE1ZTMtOWFkMS00YjdiLTkwZTItMDljYjY3MjM0NTk5XkEyXkFqcGdeQXVyNDYyMDk5MTU@._V1_.jpg',
    },
    {
      genres: ['Drama'],
      movieId: '510',
      name: 'Poetic Justice',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZWM5NTgzNTAtNTkyZC00YWQyLTg3ZDgtNzdjYTBiODg1ODFmXkEyXkFqcGdeQXVyNjYyMTYxMzk@._V1_.jpg',
    },
    {
      genres: ['Drama'],
      movieId: '524',
      name: 'Rudy',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZGUzMDU1YmQtMzBkOS00MTNmLTg5ZDQtZjY5Njk4Njk2MmRlXkEyXkFqcGdeQXVyNjc1NTYyMjg@._V1_.jpg',
    },
    {
      genres: ['Drama', 'War'],
      movieId: '527',
      name: "Schindler's List",
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNDE4OTMxMTctNmRhYy00NWE2LTg3YzItYTk3M2UwOTU5Njg4XkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_.jpg',
    },
    {
      genres: ['Action', 'Drama', 'Western'],
      movieId: '553',
      name: 'Tombstone',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BODRkYzA4MGItODE2MC00ZjkwLWI2NDEtYzU1NzFiZGU1YzA0XkEyXkFqcGdeQXVyNTAyODkwOQ@@._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Drama', 'Western'],
      movieId: '590',
      name: 'Dances with Wolves',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTY3OTI5NDczN15BMl5BanBnXkFtZTcwNDA0NDY3Mw@@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Thriller'],
      movieId: '805',
      name: 'A Time to Kill',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BOWExZTg4ZWYtOTQxMi00YWZkLTkxYzgtOTg1MTUxNzNiNDcxL2ltYWdlL2ltYWdlXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Drama'],
      movieId: '851',
      name: 'Basquiat',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTk3NTk3MzU5N15BMl5BanBnXkFtZTgwNjIwMDcyMTI@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Mystery'],
      movieId: '923',
      name: 'Citizen Kane',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYjBiOTYxZWItMzdiZi00NjlkLWIzZTYtYmFhZjhiMTljOTdkXkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Drama'],
      movieId: '1027',
      name: 'Robin Hood: Prince of Thieves',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BODM3MjA3NDM3M15BMl5BanBnXkFtZTgwMDc1NjUwMjI@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Drama'],
      movieId: '1060',
      name: 'Swingers',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZjg1ZmViMmEtYzIxNi00MzJlLTk4MDktNTE2ZDkwMzEyMjBhXkEyXkFqcGdeQXVyNDk3NzU2MTQ@._V1_.jpg',
    },
    {
      genres: ['Drama', 'War'],
      movieId: '1090',
      name: 'Platoon',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMzRjZjdlMjQtODVkYS00N2YzLWJlYWYtMGVlN2E5MWEwMWQzXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Drama'],
      movieId: '1095',
      name: 'Glengarry Glen Ross',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNTYzN2MxODMtMDBhOC00Y2M0LTgzMTItMzQ4NDIyYWIwMDEzL2ltYWdlL2ltYWdlXkEyXkFqcGdeQXVyNTc1NTQxODI@._V1_.jpg',
    },
    {
      genres: ['Drama'],
      movieId: '1103',
      name: 'Rebel Without a Cause',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTg2ODcxOTU1OV5BMl5BanBnXkFtZTgwNzA3ODI1MDE@._V1_.jpg',
    },
    {
      genres: ['Drama'],
      movieId: '1124',
      name: 'On Golden Pond',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNWQ4MGZlZmYtZjY0MS00N2JhLWE0NmMtOTMwMTk4NDQ4NjE2XkEyXkFqcGdeQXVyNTI4MjkwNjA@._V1_.jpg',
    },
    {
      genres: ['Drama'],
      movieId: '1203',
      name: '12 Angry Men',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMWU4N2FjNzYtNTVkNC00NzQ0LTg0MjAtYTJlMjFhNGUxZDFmXkEyXkFqcGdeQXVyNjc1NTYyMjg@._V1_.jpg',
    },
    {
      genres: ['Drama'],
      movieId: '1225',
      name: 'Amadeus',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNWJlNzUzNGMtYTAwMS00ZjI2LWFmNWQtODcxNWUxODA5YmU1XkEyXkFqcGdeQXVyNTIzOTk5ODM@._V1_.jpg',
    },
    {
      genres: ['Drama'],
      movieId: '1228',
      name: 'Raging Bull',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYjRmODkzNDItMTNhNi00YjJlLTg0ZjAtODlhZTM0YzgzYThlXkEyXkFqcGdeQXVyNzQ1ODk3MTQ@._V1_.jpg',
    },
    {
      genres: ['Drama', 'War'],
      movieId: '1242',
      name: 'Glory',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BODhlNjA5MDEtZDVhNS00ZmM3LTg1YzAtZGRjNjhjNTAzNzVkXkEyXkFqcGdeQXVyNjUwMzI2NzU@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Western'],
      movieId: '1266',
      name: 'Unforgiven',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BODM3YWY4NmQtN2Y3Ni00OTg0LWFhZGQtZWE3ZWY4MTJlOWU4XkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_.jpg',
    },
    {
      genres: ['Drama'],
      movieId: '1358',
      name: 'Sling Blade',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BOGIyMjc3OGMtNTlmNS00YzY1LTlkNjYtZjhmMWVhY2U2OGE3XkEyXkFqcGdeQXVyNTc1NTQxODI@._V1_.jpg',
    },
    {
      genres: ['Action', 'Drama'],
      movieId: '1586',
      name: 'G.I. Jane',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BODBkMWRmZWItZGQ3NC00ODA4LTlkYjAtODA3MzQ5Yjk4MGIzXkEyXkFqcGdeQXVyMjUzOTY1NTc@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Mystery', 'Thriller'],
      movieId: '1645',
      name: "The Devil's Advocate",
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BM2M2MDJhMDgtMmJkYy00MTgzLTkyZTktODM5NzE1MWUyNDA4XkEyXkFqcGdeQXVyNTA4NzY1MzY@._V1_.jpg',
    },
    {
      genres: ['Drama'],
      movieId: '1673',
      name: 'Boogie Nights',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BY2E2YWYxY2QtZmJmZi00MjJlLWFiYWItZTk5Y2IyMWQ1ZThhXkEyXkFqcGdeQXVyMTMxODk2OTU@._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Comedy', 'Drama'],
      movieId: '1884',
      name: 'Fear and Loathing in Las Vegas',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BY2RkY2M2N2QtZGY5ZS00YmVjLThmNTItY2ZkM2JlYmFhZWQyXkEyXkFqcGdeQXVyMjUzOTY1NTc@._V1_.jpg',
    },
    {
      genres: ['Drama'],
      movieId: '1961',
      name: 'Rain Man',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNGE3NzQzNzMtYzNiOC00ODExLWI1NzctNWY5ZGQzMWQ4MzJiXkEyXkFqcGdeQXVyNjYyMTYxMzk@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Mystery', 'Thriller'],
      movieId: '2076',
      name: 'Blue Velvet',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMzExOTczNTgtN2Q1Yy00MmI1LWE0NjgtNmIwMzdmZGNlODU1XkEyXkFqcGdeQXVyNDkzNTM2ODg@._V1_.jpg',
    },
    {
      genres: ['Drama'],
      movieId: '2231',
      name: 'Rounders',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMzViMmMxMzItYmYyYi00NGU3LWI2MDMtNjcwOWFmZTZkOTcwXkEyXkFqcGdeQXVyNDkzNTM2ODg@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Drama'],
      movieId: '2352',
      name: 'The Big Chill',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTA4MjEyMTk5NzheQTJeQWpwZ15BbWU4MDY1NDA1MTAx._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Drama'],
      movieId: '2374',
      name: 'Gung Ho',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMGU5NWQ1MTYtNzVkMy00NDFhLThkZTctM2MxMTFiN2NlMmU3L2ltYWdlXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Drama'],
      movieId: '2420',
      name: 'The Karate Kid',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNTkzY2YzNmYtY2ViMS00MThiLWFlYTEtOWQ1OTBiOGEwMTdhXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Drama'],
      movieId: '2431',
      name: 'Patch Adams',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNWJmMmZiMzAtYTllZS00MmNiLWE3ODMtMmUwMzFiMzU5MzhjXkEyXkFqcGdeQXVyNjYyMTYxMzk@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Mystery', 'Thriller'],
      movieId: '2712',
      name: 'Eyes Wide Shut',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMzQ3NWI0NDAtYTE2Zi00YWM4LWIyNGQtZmJlZmZiYzA2MmU2XkEyXkFqcGdeQXVyMjU0MjU2MjI@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Thriller'],
      movieId: '3101',
      name: 'Fatal Attraction',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYjBjNzNiNWYtYWU0NC00OTdjLTk3NmYtM2NjZjc2ZGIwOTQ1XkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Drama'],
      movieId: '3844',
      name: 'Steel Magnolias',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZTVkNWM2YjgtYjRhNC00OWQ5LWFiMDAtYWI2MTM0ZDk1ODE3XkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Crime', 'Drama'],
      movieId: '5989',
      name: 'Catch Me If You Can',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTY5MzYzNjc5NV5BMl5BanBnXkFtZTYwNTUyNTc2._V1_.jpg',
    },
    {
      genres: ['Drama', 'War'],
      movieId: '4916',
      name: 'Midway',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMTU2ZmNiNWMtYTBkZi00YzU5LThlNjUtZWUyNjU0OTIxNTM4XkEyXkFqcGdeQXVyMjUzOTY1NTc@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Drama'],
      movieId: '235',
      name: 'Ed Wood',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNTA5ZjdjNWUtZGUwNy00N2RhLWJiZmItYzFhYjU1NmYxNjY4XkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Drama', 'War'],
      movieId: '340',
      name: 'The War',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BODY0OTcxYmYtOWZkOC00NzU3LWI2ODUtOGI0OTFhMzFlMjg5XkEyXkFqcGdeQXVyNjYyMTYxMzk@._V1_.jpg',
    },
  ],
  romance: [
    {
      genres: ['Comedy', 'Drama', 'Romance'],
      movieId: '4',
      name: 'Waiting to Exhale',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYzcyMDY2YWQtYWJhYy00OGQ2LTk4NzktYWJkNDYwZWJmY2RjXkEyXkFqcGdeQXVyMTA0MjU0Ng@@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Romance'],
      movieId: '17',
      name: 'Sense and Sensibility',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BNzk1MjU3MDQyMl5BMl5BanBnXkFtZTcwNjc1OTM2MQ@@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Romance'],
      movieId: '25',
      name: 'Leaving Las Vegas',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BNDg3MDM5NTI0MF5BMl5BanBnXkFtZTcwNDY0NDk0NA@@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Drama', 'Romance'],
      movieId: '58',
      name: 'Il Postino',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZmVhNWIzOTMtYmVlZC00ZDVmLWIyODEtODEzOTAxYjAwMzVlXkEyXkFqcGdeQXVyMzIwNDY4NDI@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Romance'],
      movieId: '122',
      name: 'Boomerang',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMDRiYzVlNTgtMDExMS00NzIyLTg3YWUtOGU3YWVlYzJhZWE4XkEyXkFqcGdeQXVyMTAyOTE2ODg0._V1_.jpg',
    },
    {
      genres: ['Action', 'Drama', 'Romance', 'War'],
      movieId: '151',
      name: 'Rob Roy',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMjE2NTU2ODI0MV5BMl5BanBnXkFtZTcwNTIwODU2NA@@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Romance'],
      movieId: 'movieId',
      name: 'Mallrats',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYzAwNmMyNTEtZWI2MC00OTYzLWFlYzYtMmQ0MTdhYTYwNjNhXkEyXkFqcGdeQXVyMjUzOTY1NTc@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Romance', 'War', 'Western'],
      movieId: '266',
      name: 'Legends of the Fall',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTYwMjYxNTAyN15BMl5BanBnXkFtZTgwMTc3MjkyMTE@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Drama', 'Romance', 'War'],
      movieId: '356',
      name: 'Forrest Gump',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNWIwODRlZTUtY2U3ZS00Yzg1LWJhNzYtMmZiYmEyNmU1NjMzXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Romance'],
      movieId: '497',
      name: 'Much Ado About Nothing',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BY2Q3YTU4OTgtZTc0My00YmY1LWJmOTQtMmMwNGE2ZjBmNmIxXkEyXkFqcGdeQXVyMTAwMzUyOTc@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Drama', 'Romance'],
      movieId: '539',
      name: 'Sleepless in Seattle',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNWY1MDJkZGUtZTE2OS00ODZiLTlmNzQtMDZjNzM2ZjkwM2QxXkEyXkFqcGdeQXVyMTMxODk2OTU@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Drama', 'Fantasy', 'Romance', 'Thriller'],
      movieId: '587',
      name: 'Ghost',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMmE4ZjI3YzctNjM0YS00MjBlLWFmYjItNDRiNTk0ZmRkYjVjXkEyXkFqcGdeQXVyNjc3MjQzNTI@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Romance'],
      movieId: '613',
      name: 'Jane Eyre',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BY2YwMDYxMTctMWNkMC00NjEwLTkyNDYtNzU0M2MxOThhMWY1XkEyXkFqcGdeQXVyNjYyMTYxMzk@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Drama', 'Romance'],
      movieId: '852',
      name: 'Tin Cup',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BODFiMjRlMzItMDJkOS00NGY1LTk2YzItMjUxZmFkYjNlNjM4XkEyXkFqcGdeQXVyNjYyMTYxMzk@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Musical', 'Romance'],
      movieId: '899',
      name: "Singin' in the Rain",
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZDRjNGViMjQtOThlMi00MTA3LThkYzQtNzJkYjBkMGE0YzE1XkEyXkFqcGdeQXVyNDYyMDk5MTU@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Romance'],
      movieId: '902',
      name: "Breakfast at Tiffany's",
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNGEwMTRmZTQtMDY4Ni00MTliLTk5ZmMtOWMxYWMyMTllMDg0L2ltYWdlL2ltYWdlXkEyXkFqcGdeQXVyNjc1NTYyMjg@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Romance'],
      movieId: '912',
      name: 'Casablanca',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BY2IzZGY2YmEtYzljNS00NTM5LTgwMzUtMzM1NjQ4NGI0OTk0XkEyXkFqcGdeQXVyNDYyMDk5MTU@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Musical', 'Romance'],
      movieId: '1088',
      name: 'Dirty Dancing',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTc3MDY3ODQ2OV5BMl5BanBnXkFtZTgwOTQ2NTYxMTE@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Comedy', 'Fantasy', 'Romance'],
      movieId: '1197',
      name: 'The Princess Bride',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYzdiOTVjZmQtNjAyNy00YjA2LTk5ZTAtNmJkMGQ5N2RmNjUxXkEyXkFqcGdeQXVyMjUzOTY1NTc@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Fantasy', 'Romance'],
      movieId: '1265',
      name: 'Groundhog Day',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZWIxNzM5YzQtY2FmMS00Yjc3LWI1ZjUtNGVjMjMzZTIxZTIxXkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Musical', 'Romance'],
      movieId: '1380',
      name: 'Grease',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZmUyMDEyOTgtZmUwOS00NTdkLThlNzctNTM1ODQ4M2VhMjdhXkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Romance'],
      movieId: '1441',
      name: 'Benny & Joon',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTUwMzkyNjIzMl5BMl5BanBnXkFtZTcwMDMyNDcyNA@@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Romance'],
      movieId: '1611',
      name: 'My Own Private Idaho',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZDgxMGU3YTEtODEzOC00MGVlLTk4OWUtYmY0ODU0OTI1NmMxL2ltYWdlL2ltYWdlXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Romance'],
      movieId: '1678',
      name: 'The Joy Luck Club',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYWY3MjZlZjItYzBlMy00OTY0LWJjN2QtNGU4ZTk2YzY2MzJlXkEyXkFqcGdeQXVyNTM0NTU5Mg@@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Romance'],
      movieId: '1704',
      name: 'Good Will Hunting',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BOTI0MzcxMTYtZDVkMy00NjY1LTgyMTYtZmUxN2M3NmQ2NWJhXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Romance'],
      movieId: '1721',
      name: 'Titanic',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMDdmZGU3NDQtY2E5My00ZTliLWIzOTUtMTY4ZGI1YjdiNjk3XkEyXkFqcGdeQXVyNTA4NzY1MzY@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Romance'],
      movieId: '1735',
      name: 'Great Expectations',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNzk2MzQ4ZDctYzg0My00MzY2LTlmY2QtMWUxZTcxM2UwNzRmXkEyXkFqcGdeQXVyMjUzOTY1NTc@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Drama', 'Romance'],
      movieId: '1784',
      name: 'As Good as It Gets',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNWMxZTgzMWEtMTU0Zi00NDc5LWFkZjctMzUxNDIyNzZiMmNjXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Drama', 'Romance'],
      movieId: '1883',
      name: 'Bulworth',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTY2NTM5NjIyOV5BMl5BanBnXkFtZTgwMzUwNzc3NjE@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Musical', 'Romance'],
      movieId: '1947',
      name: 'West Side Story',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTM0NDAxOTI5MF5BMl5BanBnXkFtZTcwNjI4Mjg3NA@@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Romance', 'War'],
      movieId: '2067',
      name: 'Doctor Zhivago',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNzdmZTk4MTktZmExNi00OWEwLTgxZDctNTE4NWMwNjc1Nzg2XkEyXkFqcGdeQXVyNjc1NTYyMjg@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Romance'],
      movieId: '2144',
      name: 'Sixteen Candles',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTgzNTkxMTkxMl5BMl5BanBnXkFtZTgwMjE3NjkzMTE@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Drama', 'Romance'],
      movieId: '2145',
      name: 'Pretty in Pink',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BOGE3ZmVjMzMtMDcxNi00YjM5LTg3NjMtZWMxYjlhNTk2MmZjXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Romance'],
      movieId: '2146',
      name: "St. Elmo's Fire",
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZjdlMTJkNDQtMmI5ZS00OTA1LWI2YTYtN2I5MGQwODhjOTQwXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Romance'],
      movieId: '2269',
      name: 'Indecent Proposal',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BODk3OWJhMTUtMTU2MC00ZjJmLTk2OGYtN2NiZGMxNmY4NzU3L2ltYWdlXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Romance'],
      movieId: '2340',
      name: 'Meet Joe Black',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNTc0MzRmMTgtMTk4OS00MzdkLWJjNWMtZWJmZjlkYTI0YWRiL2ltYWdlL2ltYWdlXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Drama', 'Romance'],
      movieId: '2369',
      name: 'Desperately Seeking Susan',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNTViMzE5MmQtNWUwNC00NWNkLWIxMWUtYzM5NWRmOTk5MDQ2XkEyXkFqcGdeQXVyMTY5Nzc4MDY@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Drama', 'Romance'],
      movieId: '2396',
      name: 'Shakespeare in Love',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BM2ZkNjM5MjEtNTBlMC00OTI5LTgyYmEtZDljMzNmNzhiNzY0XkEyXkFqcGdeQXVyNDYyMDk5MTU@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Romance'],
      movieId: '2424',
      name: "You've Got Mail",
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZTcxNzgzZjMtYzZiZC00MmE1LTg3MzQtZDAxMTYyZWE4MDNhL2ltYWdlXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Romance'],
      movieId: '2485',
      name: "She's All That",
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BY2Y0N2YyOTQtMGNiYy00ZDViLTgxYmItODkxNzlkMWVjNTFkXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Drama', 'Fantasy', 'Romance'],
      movieId: '2797',
      name: 'Big',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMDQ1ODM5MTMtMjAwYi00ZGUxLTliNTMtN2ZhODAwMjVhMTRlXkEyXkFqcGdeQXVyNTAyODkwOQ@@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Romance'],
      movieId: '123545',
      name: 'The Blue Lagoon',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BOWU2ZDIxY2UtNzM5NS00MWUwLTkxN2QtMmI3NDZkNTA2OTYxXkEyXkFqcGdeQXVyMTA0MjU0Ng@@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Romance', 'Thriller'],
      movieId: '3257',
      name: 'The Bodyguard',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYThkMTM4ZTMtN2M3OS00ODRjLTkxMTgtZTM4ZmZlNGZjOGIxXkEyXkFqcGdeQXVyMjUzOTY1NTc@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Romance'],
      movieId: '3360',
      name: 'Hoosiers',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTYyNTc0OTUwNV5BMl5BanBnXkFtZTcwODA3NzE0NA@@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Romance'],
      movieId: '3426',
      name: 'Jungle Fever',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMjM5MTQxMDk2Ml5BMl5BanBnXkFtZTgwODQ2MDc3NjE@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Romance'],
      movieId: '3528',
      name: 'The Prince of Tides',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BOGQ4NjlhZTktOTBlMi00OTE1LTk1MTAtMDExODY2NzRiZDIyXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Romance'],
      movieId: '3668',
      name: 'Romeo and Juliet',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BM2I5ZDRhMjMtNzVmMy00YTExLWJiZjktODdjMjM0ZDYyY2ZjXkEyXkFqcGdeQXVyMjUzOTY1NTc@._V1_.jpg',
    },
    {
      genres: ['Drama', 'Romance'],
      movieId: '4041',
      name: 'An Officer and a Gentleman',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNTM5NmY2MTktODRiMS00NTQwLTk2ODEtZTFhYjAyMTZmMTc5XkEyXkFqcGdeQXVyMTA0MjU0Ng@@._V1_.jpg',
    },
  ],
  animation: [
    {
      genres: ['Adventure', 'Animation', 'Children', 'Comedy', 'Fantasy'],
      movieId: '1',
      name: 'Toy Story',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMDU2ZWJlMjktMTRhMy00ZTA5LWEzNDgtYmNmZTEwZTViZWJkXkEyXkFqcGdeQXVyNDQ2OTk4MzI@._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Animation', 'Children', 'Comedy', 'Fantasy'],
      movieId: '3114',
      name: 'Toy Story 2',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMWM5ZDcxMTYtNTEyNS00MDRkLWI3YTItNThmMGExMWY4NDIwXkEyXkFqcGdeQXVyNjUwNzk3NDc@._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Animation', 'Children', 'Comedy', 'Fantasy'],
      movieId: '78499',
      name: 'Toy Story 3',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTgxOTY4Mjc0MF5BMl5BanBnXkFtZTcwNTA4MDQyMw@@._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Animation', 'Children', 'Drama', 'Musical', 'IMAX'],
      movieId: '364',
      name: 'The Lion King',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYTYxNGMyZTYtMjE3MS00MzNjLWFjNmYtMDk3N2FmM2JiM2M1XkEyXkFqcGdeQXVyNjY5NDU4NzI@._V1_.jpg',
    },
    {
      genres: ['Animation', 'Children', 'Fantasy', 'Musical'],
      movieId: '551',
      name: 'The Nightmare Before Christmas',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNWE4OTNiM2ItMjY4Ni00ZTViLWFiZmEtZGEyNGY2ZmNlMzIyXkEyXkFqcGdeQXVyMDU5NDcxNw@@._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Animation', 'Children', 'Comedy', 'Musical'],
      movieId: '588',
      name: 'Aladdin',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BY2Q2NDI1MjUtM2Q5ZS00MTFlLWJiYWEtNTZmNjQ3OGJkZDgxXkEyXkFqcGdeQXVyNTI4MjkwNjA@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Animation', 'Horror', 'Sci-Fi'],
      movieId: '610',
      name: 'Heavy Metal',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BOTc2NzM1ODgtM2RkYi00M2U4LWE4NzEtMDMzZGUzYmI1ZDUzL2ltYWdlXkEyXkFqcGdeQXVyNTAyODkwOQ@@._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Animation', 'Children', 'Comedy', 'Fantasy', 'Sci-Fi'],
      movieId: '673',
      name: 'Space Jam',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYjA3ZmMwNTUtNGM2Ni00YjUyLWE5ZDYtY2Y4YzhmYzlhYWI2XkEyXkFqcGdeQXVyMjUzOTY1NTc@._V1_.jpg',
    },
    {
      genres: ['Animation', 'Children', 'Fantasy', 'Musical', 'Romance'],
      movieId: '1022',
      name: 'Cinderella',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BOGU0NGQ1MzEtODIwZS00YTdiLWJhMzQtN2RkN2YzNGVjNDZkXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Animation', 'Children', 'Drama', 'Musical'],
      movieId: '1029',
      name: 'Dumbo',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNWVmNWQ2OTQtNzJlNC00ZmQwLTg4ZTktZTNmM2IxZTlkOGM3L2ltYWdlXkEyXkFqcGdeQXVyNTAyODkwOQ@@._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Animation', 'Children', 'Musical'],
      movieId: '1030',
      name: "Pete's Dragon",
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMjJkMjcyOTktYTIwNC00MTY3LWE4ZTAtMTdlODg0NDE3YTQ1XkEyXkFqcGdeQXVyNjM1MTQ0NTQ@._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Animation', 'Children', 'Fantasy', 'Musical'],
      movieId: '1032',
      name: 'Alice in Wonderland',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTgyMjM2NTAxMF5BMl5BanBnXkFtZTgwNjU1NDc2MTE@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Animations', 'Sci-Fi'],
      movieId: '1988',
      name: 'Akira',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BM2ZiZTk1ODgtMTZkNS00NTYxLWIxZTUtNWExZGYwZTRjODViXkEyXkFqcGdeQXVyMTE2MzA3MDM@._V1_.jpg',
    },
    {
      genres: ['Animation', 'Children', 'Comedy', 'Romance'],
      movieId: '2080',
      name: 'Lady and the Tramp',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BODk4YWI2MzItYzc2Yi00M2U0LWFhY2MtOTgyODM2NWE0MDcyXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Animation', 'Children'],
      movieId: '2085',
      name: '101 Dalmations',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMGI2NTQ2N2EtNDExMS00OWM2LTkzZWItZGUzY2M2MDFjODk0XkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Animation', 'Children', 'Comedy', 'Drama', 'Fantasy'],
      movieId: '2123',
      name: 'All Dogs Go to Heaven',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMTI4ZWRmNTAtOWIyZC00Njk0LWIzZGItYjE0NDVlM2Q4ZWJjXkEyXkFqcGdeQXVyNTUyMzE4Mzg@._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Animation', 'Children', 'Comedy'],
      movieId: '2141',
      name: 'An American Tail',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BOGNjODEyNDgtYWNiYi00NDEwLWI2YTMtM2JmZWYyNjg2ZTczXkEyXkFqcGdeQXVyMzczMzE2ODM@._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Animation', 'Children', 'Comedy', 'Musical'],
      movieId: '3034',
      name: 'Robin Hood',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYjUwMzhkM2ItMTU2OC00OTQ5LWJlMDUtMzRmYjc0NDUyNGVhL2ltYWdlL2ltYWdlXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Animation', 'Fantasy', 'Sci-Fi'],
      movieId: '3687',
      name: 'Light Years',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYjMzNTU2ODktNGQ1NC00MDJjLTk5MWUtZmFlYWRiNDUxNGUwXkEyXkFqcGdeQXVyNTAyODkwOQ@@._V1_.jpg',
    },
    {
      genres: ['Animation', 'Children'],
      movieId: '4090',
      name: 'The Brave Little Toaster',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYTc4NDhlYjgtOGRhYS00NzFiLTg1ZGItN2RhNDc2OTMyOTU4XkEyXkFqcGdeQXVyMTEwNDU1MzEy._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Animation', 'Children', 'Comedy', 'Fantasy', 'Romance'],
      movieId: '4306',
      name: 'Shrek',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BOGZhM2FhNTItODAzNi00YjA0LWEyN2UtNjJlYWQzYzU1MDg5L2ltYWdlL2ltYWdlXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Animation', 'Children', 'Comedy', 'Fantasy', 'Romance'],
      movieId: '8360',
      name: 'Shrek 2',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMDJhMGRjN2QtNDUxYy00NGM3LThjNGQtMmZiZTRhNjM4YzUxL2ltYWdlL2ltYWdlXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Animation', 'Fantasy'],
      movieId: '5618',
      name: 'Spirited Away',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMjlmZmI5MDctNDE2YS00YWE0LWE5ZWItZDBhYWQ0NTcxNWRhXkEyXkFqcGdeQXVyMTMxODk2OTU@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Animation', 'Drama', 'Fantasy'],
      movieId: '3000',
      name: 'Princess Mononoke',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNGIzY2IzODQtNThmMi00ZDE4LWI5YzAtNzNlZTM1ZjYyYjUyXkEyXkFqcGdeQXVyODEzNjM5OTQ@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Animation', 'Fantasy'],
      movieId: '6857',
      name: 'Ninja Scroll',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BOTMyZGI4N2YtMzdkNi00MDZmLTg4NmItMzg0ODY5NjdhZjYwL2ltYWdlL2ltYWdlXkEyXkFqcGdeQXVyMzM4MjM0Nzg@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Animation', 'Children', 'Comedy'],
      movieId: '8961',
      name: 'The Incredibles',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTY5OTU0OTc2NV5BMl5BanBnXkFtZTcwMzU4MDcyMQ@@._V1_.jpg',
    },
    {
      genres: ['Animation', 'Comedy'],
      movieId: '54272',
      name: 'The Simpsons Movie',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTgxMDczMTA5N15BMl5BanBnXkFtZTcwMzk1MzMzMw@@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Animation', 'Children', 'Comedy', 'Fantasy'],
      movieId: '108932',
      name: 'The Lego Movie',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTg4MDk1ODExN15BMl5BanBnXkFtZTgwNzIyNjg3MDE@._V1_.jpg',
    },
    {
      genres: ['Action', 'Animation', 'Comedy'],
      movieId: '115617',
      name: 'Big Hero 6',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMDliOTIzNmUtOTllOC00NDU3LWFiNjYtMGM0NDc1YTMxNjYxXkEyXkFqcGdeQXVyNTM3NzExMDQ@._V1_.jpg',
    },
    {
      genres: ['Animation', 'Children', 'Drama'],
      movieId: '1033',
      name: 'The Fox and the Hound',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMDQzZWRlYjctMjE0ZS00NWU5LWE3NzktYzZiNzJiM2UxMDczXkEyXkFqcGdeQXVyNjUwNzk3NDc@._V1_.jpg',
    },
    {
      genres: ['Animation', 'Children', 'Comedy', 'Musical', 'Romance'],
      movieId: '2081',
      name: 'The Little Mermaid',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BN2JlZTBhYTEtZDE3OC00NTA3LTk5NTQtNjg5M2RjODllM2M0XkEyXkFqcGdeQXVyNjk1Njg5NTA@._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Animation', 'Children', 'Drama', 'Fantasy'],
      movieId: '2138',
      name: 'Watership Down',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMzZiODUwNzktNzBiZi00MDc4LThkMGMtZmE3MTE0M2E1MTM3L2ltYWdlXkEyXkFqcGdeQXVyNTAyODkwOQ@@._V1_.jpg',
    },
    {
      genres: ['Animation', 'Children', 'Comedy'],
      movieId: '3751',
      name: 'Chicken Run',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNDgxNjZlZDYtZGJmZC00Mjg0LWEwYzctYWQ0MWFjNTM3ZmM4XkEyXkFqcGdeQXVyNTM5NzI0NDY@._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Animation', 'Children', 'Fantasy'],
      movieId: '4519',
      name: 'The Land Before Time',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNDVhZjVmZWYtYTE0OC00MGFjLWI1YWQtZmJhNmE5NzI4ZWE4XkEyXkFqcGdeQXVyMzczMzE2ODM@._V1_.jpg',
    },
    {
      genres: ['Action', 'Animation', 'Comedy', 'Crime', 'Drama', 'Romance', 'Thriller'],
      movieId: '4719',
      name: 'Osmosis Jones',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTk5NTg2NzM0OV5BMl5BanBnXkFtZTYwNTk5Mjg5._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Animation', 'Children', 'Comedy'],
      movieId: '5218',
      name: 'Ice Age',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BOGEwMTQyMDktMWUwZC00MzExLTg1MGMtYWJiNWNhMzIyMGU5XkEyXkFqcGdeQXVyOTYyMTY2NzQ@._V1_.jpg',
    },
    {
      genres: ['Animation', 'Comedy', 'Musical'],
      movieId: '5879',
      name: 'Eight Crazy Nights',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTk1NTU4NjE5OV5BMl5BanBnXkFtZTYwMTQ3OTY2._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Animation', 'Children', 'Comedy'],
      movieId: '6377',
      name: 'Finding Nemo',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZTAzNWZlNmUtZDEzYi00ZjA5LWIwYjEtZGM1NWE1MjE4YWRhXkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_.jpg',
    },
    {
      genres: ['Action', 'Animation', 'Drama', 'Sci-Fi'],
      movieId: '27660',
      name: 'The Animatrix',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZWRiODljNzUtZDkwOC00N2EwLTllMDAtOGQ4MmQ2YWY2MTBiXkEyXkFqcGdeQXVyNDQ0MTYzMDA@._V1_.jpg',
    },
    {
      genres: ['Animation', 'Comedy', 'Fantasy', 'Musical', 'Romance'],
      movieId: '37729',
      name: 'Corpse Bride',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTk1MTY1NjU4MF5BMl5BanBnXkFtZTcwNjIzMTEzMw@@._V1_.jpg',
    },
    {
      genres: ['Animation', 'Children', 'Comedy'],
      movieId: '45517',
      name: 'Cars',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTg5NzY0MzA2MV5BMl5BanBnXkFtZTYwNDc3NTc2._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Animation', 'Children', 'Comedy', 'IMAX'],
      movieId: '87876',
      name: 'Cars 2',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTUzNTc3MTU3M15BMl5BanBnXkFtZTcwMzIxNTc3NA@@._V1_.jpg',
    },
    {
      genres: ['Animation', 'Children', 'Drama'],
      movieId: '50872',
      name: 'Ratatouille',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTMzODU0NTkxMF5BMl5BanBnXkFtZTcwMjQ4MzMzMw@@._V1_.jpg',
    },
    {
      genres: ['Animation', 'Children', 'Comedy', 'Fantasy', 'Musical', 'Romance', 'IMAX'],
      movieId: '81847',
      name: 'Tangled',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTAxNDYxMjg0MjNeQTJeQWpwZ15BbWU3MDcyNTk2OTM@._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Animation', 'Children', 'Romance', 'Sci-Fi'],
      movieId: '60069',
      name: 'WALL•E',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMjExMTg5OTU0NF5BMl5BanBnXkFtZTcwMjMxMzMzMw@@._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Animation', 'Children', 'Fantasy'],
      movieId: '65261',
      name: 'Ponyo',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BOTc3YmM3N2QtODZkMC00ZDE5LThjMTQtYTljN2Y1YTYwYWJkXkEyXkFqcGdeQXVyODEzNjM5OTQ@._V1_.jpg',
    },
    {
      genres: ['Animation', 'Fantasy', 'Thriller'],
      movieId: '66097',
      name: 'Coraline',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMzQxNjM5NzkxNV5BMl5BanBnXkFtZTcwMzg5NDMwMg@@._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Animation', 'Children', 'Comedy', 'Crime'],
      movieId: '72226',
      name: 'Fantastic Mr. Fox',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BOGUwYTU4NGEtNDM4MS00NDRjLTkwNmQtOTkwMWMyMjhmMjdlXkEyXkFqcGdeQXVyMTMxODk2OTU@._V1_.jpg',
    },
  ],
  crime: [
    {
      genres: ['Crime', 'Drama'],
      movieId: '16',
      name: 'Casino',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMTcxOWYzNDYtYmM4YS00N2NkLTk0NTAtNjg1ODgwZjAxYzI3XkEyXkFqcGdeQXVyNTA4NzY1MzY@._V1_.jpg',
    },
    {
      genres: ['Action', 'Crime', 'Thriller'],
      movieId: '6',
      name: 'Heat',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNGMwNzUwNjYtZWM5NS00YzMyLWI4NjAtNjM0ZDBiMzE1YWExXkEyXkFqcGdeQXVyNDk3NzU2MTQ@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Crime', 'Thriller'],
      movieId: '21',
      name: 'Get Shorty',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMjAwODYzNDY4Ml5BMl5BanBnXkFtZTcwODkwNTgzNA@@._V1_.jpg',
    },
    {
      genres: ['Crime', 'Mystery', 'Thriller'],
      movieId: '50',
      name: 'The Usual Suspects',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNDg1OWQyNzAtZjRkNS00OGZmLWIyNWYtZTMxZDIyNGRkOWY2XkEyXkFqcGdeQXVyMTgxOTIzNzk@._V1_.jpg',
    },
    {
      genres: ['Adventure', 'Comedy', 'Crime', 'Romance'],
      movieId: '101',
      name: 'Bottle Rocket',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNzFlYWQxMjMtYTdmOC00NDA0LWI5NWQtNjc5OTc1ZDdkOGExXkEyXkFqcGdeQXVyMjUzOTY1NTc@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Crime', 'Thriller'],
      movieId: '170',
      name: 'Hackers',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNmExMTkyYjItZTg0YS00NWYzLTkwMjItZWJiOWQ2M2ZkYjE4XkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Action', 'Crime', 'Sci-Fi'],
      movieId: '173',
      name: 'Judge Dredd',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYmM1NzUyY2YtOTU4My00ZmFmLWI4ZjYtYzJlM2JlOTBhZmIzXkEyXkFqcGdeQXVyNjE5MjUyOTM@._V1_.jpg',
    },
    {
      genres: ['Action', 'Crime', 'Thriller'],
      movieId: '185',
      name: 'The Net',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNjE4MjQyNjUtZTNmYy00ZmNlLTk2ODUtN2YzODIwNDdkM2EwXkEyXkFqcGdeQXVyMjUzOTY1NTc@._V1_.jpg',
    },
    {
      genres: ['Action', 'Crime', 'Thriller'],
      movieId: '288',
      name: 'Natural Born Killers',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTI2NTU2Nzc0MV5BMl5BanBnXkFtZTcwMzY1OTM2MQ@@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Crime', 'Drama', 'Thriller'],
      movieId: '296',
      name: 'Pulp Fiction',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNGNhMDIzZTUtNTBlZi00MTRlLWFjM2ItYzViMjE3YzI5MjljXkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_.jpg',
    },
    {
      genres: ['Action', 'Crime', 'Drama', 'Thriller'],
      movieId: '293',
      name: 'Léon: The Professional',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BODllNWE0MmEtYjUwZi00ZjY3LThmNmQtZjZlMjI2YTZjYmQ0XkEyXkFqcGdeQXVyNTc1NTQxODI@._V1_.jpg',
    },
    {
      genres: ['Crime', 'Drama'],
      movieId: '318',
      name: 'The Shawshank Redemption',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMDFkYTc0MGEtZmNhMC00ZDIzLWFmNTEtODM1ZmRlYWMwMWFmXkEyXkFqcGdeQXVyMTMxODk2OTU@._V1_.jpg',
    },
    {
      genres: ['Crime', 'Drama'],
      movieId: '409',
      name: 'Above the Rim',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNDE5M2I4OWEtZDUyMS00ODYwLTkxNWYtZmNlNjEzOWRlYjc0XkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Action', 'Adventure', 'Crime', 'Thriller'],
      movieId: '464',
      name: 'Hard Target',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMjc5YmU3MjUtNmRhYy00MjQ5LWI1ZTMtOGQzYTE1N2I4ZTEzXkEyXkFqcGdeQXVyMjUzOTY1NTc@._V1_.jpg',
    },
    {
      genres: ['Action', 'Crime', 'Thriller'],
      movieId: '479',
      name: 'Judgment Night',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMmYzNDBhMTItZGJjMy00MjE1LTk2YmQtZGY2ZmQ0NDYzOTM1XkEyXkFqcGdeQXVyMjUzOTY1NTc@._V1_.jpg',
    },
    {
      genres: ['Action', 'Crime', 'Drama'],
      movieId: '493',
      name: 'Menace II Society',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNGE3MGI0MzItNjJjNC00ZTUzLTlmZTctOGUyMDllMWM2OTcxXkEyXkFqcGdeQXVyMjQ1MjYzOTQ@._V1_.jpg',
    },
    {
      genres: ['Crime', 'Thriller'],
      movieId: '555',
      name: 'True Romance',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYWRhYWJjNGEtMjNhNi00NzFkLTk1ZGUtNjNmM2FlNTNhNWRjXkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_.jpg',
    },
    {
      genres: ['Crime', 'Horror', 'Thriller'],
      movieId: '593',
      name: 'The Silence of the Lambs',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNjNhZTk0ZmEtNjJhMi00YzFlLWE1MmEtYzM1M2ZmMGMwMTU4XkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Crime', 'Drama', 'Thriller'],
      movieId: '608',
      name: 'Fargo',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNDJiZDgyZjctYmRjMS00ZjdkLTkwMTEtNGU1NDg3NDQ0Yzk1XkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_.jpg',
    },
    {
      genres: ['Comedy', 'Crime', 'Drama'],
      movieId: '778',
      name: 'Trainspotting',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMzA5Zjc3ZTMtMmU5YS00YTMwLWI4MWUtYTU0YTVmNjVmODZhXkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_.jpg',
    },
    {
      genres: ['Crime', 'Drama'],
      movieId: '858',
      name: 'The Godfather',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BM2MyNjYxNmUtYTAwNi00MTYxLWJmNWYtYzZlODY3ZTk3OTFlXkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_.jpg',
    },
    {
      genres: ['Crime', 'Drama'],
      movieId: '1221',
      name: 'The Godfather: Part II',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMWMwMGQzZTItY2JlNC00OWZiLWIyMDctNDk2ZDQ2YjRjMWQ0XkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_.jpg',
    },
    {
      genres: ['Crime', 'Drama'],
      movieId: '2023',
      name: 'The Godfather: Part III',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNWFlYWY2YjYtNjdhNi00MzVlLTg2MTMtMWExNzg4NmM5NmEzXkEyXkFqcGdeQXVyMDk5Mzc5MQ@@._V1_.jpg',
    },
    {
      genres: ['Action', 'Crime'],
      movieId: '998',
      name: 'Set it Off',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZTA3YzA1YjEtOWUxNy00NDk4LTk2ZjUtNmFlNjZlNTdkODNmXkEyXkFqcGdeQXVyMjc1NDA2OA@@._V1_.jpg',
    },
    {
      genres: ['Crime', 'Mystery', 'Thriller'],
      movieId: '1092',
      name: 'Basic Instinct',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZjk0YmJkNjItNDY3Mi00ZWFiLWEwY2EtMDJlZWJlOWZkNzJlXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Crime', 'Mystery', 'Thriller'],
      movieId: '1089',
      name: 'Reservoir Dogs',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZmExNmEwYWItYmQzOS00YjA5LTk2MjktZjEyZDE1Y2QxNjA1XkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Crime', 'Drama', 'Sci-Fi', 'Thriller'],
      movieId: '1206',
      name: 'A Clockwork Orange',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTY3MjM1Mzc4N15BMl5BanBnXkFtZTgwODM0NzAxMDE@._V1_.jpg',
    },
    {
      genres: ['Crime', 'Drama'],
      movieId: '1213',
      name: 'Goodfellas',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BY2NkZjEzMDgtN2RjYy00YzM1LWI4ZmQtMjIwYjFjNmI3ZGEwXkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_.jpg',
    },
    {
      genres: ['Crime', 'Thriller', 'War'],
      movieId: '1267',
      name: 'The Manchurian Candidate',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZDU2YjA4MmItODk0OS00OTllLWFmNzUtMTg2ZmM3YWYzOGFmXkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_.jpg',
    },
    {
      genres: ['Crime', 'Drama', 'Thriller'],
      movieId: '1344',
      name: 'Cape Fear',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNjdhNzZlYzYtYTBlNS00NTJiLWI2ZWUtMDI2YzI2MzM5NjY4XkEyXkFqcGdeQXVyNjc1NTYyMjg@._V1_.jpg',
    },
    {
      genres: ['Action', 'Comedy', 'Crime', 'Drama', 'Sci-Fi'],
      movieId: '1396',
      name: 'Sneakers',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZTg0MTU0Y2YtNWEyNC00NDU3LWJhNjYtZGIzMWI0YWMwMTdhXkEyXkFqcGdeQXVyNjMwMjk0MTQ@._V1_.jpg',
    },
    {
      genres: ['Crime', 'Drama'],
      movieId: '1466',
      name: 'Donnie Brasco',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYzMzMDZkYWEtODIzNS00YjI3LTkxNTktOWEyZGM3ZWI2MWM4XkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_.jpg',
    },
    {
      genres: ['Action', 'Crime', 'Drama', 'Thriller'],
      movieId: '1573',
      name: 'Face/Off',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYzFjNzIxMmEtMzY5NS00YTgzLTkwYWEtN2FjMmY0NmNkZWY3XkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Crime', 'Drama', 'Mystery', 'Thriller'],
      movieId: '1620',
      name: 'Kiss the Girls',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMjE2MWE1ZDYtNjNkYS00YjZmLWJkZjctOTYzYTVjMDFiN2M5XkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Crime', 'Drama', 'Thriller'],
      movieId: '1729',
      name: 'Jackie Brown',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNmY5ODRmYTItNWU0Ni00MWE3LTgyYzUtYjZlN2Q5YTcyM2NmXkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_.jpg',
    },
    {
      genres: ['Action', 'Crime', 'Thriller'],
      movieId: '1792',
      name: 'U.S. Marshals',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYmM1MTVhMzctMWVhNi00NDM0LWJlNGItMDE4ZTY0ZTAwODgzXkEyXkFqcGdeQXVyMjUzOTY1NTc@._V1_.jpg',
    },
    {
      genres: ['Action', 'Comedy', 'Crime', 'Drama'],
      movieId: '2000',
      name: 'Lethal Weapon',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZTllNWNlZjctMWQwMS00ZDc3LTg5ZjMtNzhmNzhjMmVhYTFlXkEyXkFqcGdeQXVyNTc1NTQxODI@._V1_.jpg',
    },
    {
      genres: ['Crime', 'Drama', 'Film-Noir', 'Thriller'],
      movieId: '2186',
      name: 'Strangers on a Train',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNWJjOGM4NmEtNDE2YS00OGEyLTkwZWItMGM4YzdhZDZhMzNhXkEyXkFqcGdeQXVyMDI2NDg0NQ@@._V1_.jpg',
    },
    {
      genres: ['Action', 'Crime', 'Drama'],
      movieId: '2194',
      name: 'The Untouchables',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYTVjYWJmMWQtYWU4Ni00MWY3LWI2YmMtNTI5MDE0MWVmMmEzL2ltYWdlXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
    {
      genres: ['Action', 'Crime', 'Thriller'],
      movieId: '2278',
      name: 'Ronin',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BOWVkYzliZGEtODIxMi00MDQwLThjMDAtNzI3M2NjYjg4NDE5XkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_.jpg',
    },
    {
      genres: ['Crime', 'Drama'],
      movieId: '2332',
      name: 'Belly',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BODBkZjg5ZGEtN2I4ZS00ZjBiLWIyMWItZGY2YjY3YjFlOWU4XkEyXkFqcGdeQXVyODg2MjMxMTc@._V1_.jpg',
    },
    {
      genres: ['Action', 'Crime'],
      movieId: '2616',
      name: 'Dick Tracy',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMzA5MDg5ZDAtOWE1YS00Nzg2LTk5NzUtMDY3ZDZlN2U2M2ZlXkEyXkFqcGdeQXVyNjUwNzk3NDc@._V1_.jpg',
    },
    {
      genres: ['Action', 'Crime', 'Drama', 'Thriller'],
      movieId: '2959',
      name: 'Fight Club',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNDIzNDU0YzEtYzE5Ni00ZjlkLTk5ZjgtNjM3NWE4YzA3Nzk3XkEyXkFqcGdeQXVyMjUzOTY1NTc@._V1_.jpg',
    },
    {
      genres: ['Crime', 'Drama'],
      movieId: '3147',
      name: 'The Green Mile',
      imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTUxMzQyNjA5MF5BMl5BanBnXkFtZTYwOTU2NTY3._V1_.jpg',
    },
    {
      genres: ['Crime', 'Drama', 'Film-Noir', 'Mystery', 'Thriller'],
      movieId: '4848',
      name: 'Mulholland Drive',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BYzE2ZGJlMjQtYzJlMi00MDQxLWIxNDQtZTY0MDBlODQyZTU2XkEyXkFqcGdeQXVyMjUzOTY1NTc@._V1_.jpg',
    },
    {
      genres: ['Action', 'Crime', 'Drama', 'Thriller'],
      movieId: '3275',
      name: 'The Boondock Saints',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BNTliMTg0ZTgtNTJiYi00MjFkLThhYTUtNDAwNTliMmVkNjVkXkEyXkFqcGdeQXVyMjUzOTY1NTc@._V1_.jpg',
    },
    {
      genres: ['Crime', 'Horror', 'Mystery', 'Thriller'],
      movieId: '3535',
      name: 'American Psycho',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BZTM2ZGJmNjQtN2UyOS00NjcxLWFjMDktMDE2NzMyNTZlZTBiXkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_.jpg',
    },
    {
      genres: ['Crime', 'Drama', 'Thriller'],
      movieId: '4776',
      name: 'Training Day',
      imageUrl:
        'https://m.media-amazon.com/images/M/MV5BMDZkMTUxYWEtMDY5NS00ZTA5LTg3MTItNTlkZWE1YWRjYjMwL2ltYWdlL2ltYWdlXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    },
  ],
};
